import Group from './group';
import Submission from './submission';
import Explanation from './explanation';

export default class Documentation {
  id: number;
  group: Group | null = null;
  index: string | number;
  name: string;
  description: string;
  documentationGroupId?: number;
  //  submissions: null | Submission;

  constructor(values: DocumentationConstructorValues) {
    this.id = values.id;
    this.group = values.group;
    this.index = values.index;
    this.name = values.name;
    this.description = values.description;
  }
}

export interface DocumentationConstructorValues {
  id: number;
  name: string;
  index: string | number;
  description: string;
  group: Group | null;
}


export enum DocumentationId {
  InternalRules = 1,
  InstitutionalProcedure = 2,
  StrategicAgenda = 3,
  ProceduresManuals = 4,
  OrgStructure = 5,
  DocumentFollowing = 6,
  FormsDescription = 7,
  RulesOfProcedure = 8,
  InstitutionalProjects = 9,
  BudgetExecution = 10,
  Statistics = 11,
  DevelopedPrograms = 12,
  PublicActContractings = 13,
  Hiring = 14,
  Designation = 15,
  Payroll = 16,
  ReprExpenses = 17,
  PerDiems = 18,
  PerDiemsDummy = 19,
  InformationRequest = 20,
  InformationRequestDummy = 21,
  CitizenAdmonActs = 22,
  CodeOfEthics = 23,
  Others = 24,
}

export const dummyDocumentationsMap = new Map<DocumentationId, DocumentationId>([
  [DocumentationId.PerDiemsDummy, DocumentationId.PerDiems],
  [DocumentationId.InformationRequestDummy, DocumentationId.InformationRequest],
]);

export {
  Group,
  Submission,
  Explanation,
};
